<template>
  <v-card :class="print == 'true' ? 'print-card' : 'backgroundWhite'" flat>
    <v-card-title v-if="title || subtitle" class="backgroundWhite title-chart fxd-height pb-0">
      <TooltipVT v-if="tooltip" :title="title" type="text" :text="tooltip" />
      <span v-else>{{ title }}</span>
      <span v-if="subtitle" class="chart-subtitle pl-2 text-subtitle-1 font-weight-medium primary--text">
        ({{ prefix }}{{ $numberWithCommas(subtitle) }})</span
      >
      <span v-if="description" class="caption font-weight-medium primaryGrey--text">
        <TooltipVT v-if="tooltip" title="*" type="text" color="primary" :text="description" />
      </span>
    </v-card-title>
    <v-skeleton-loader v-if="!updated_chart_data" type="image"></v-skeleton-loader>
    <v-card-text v-else class="py-0 px-1">
      <p
        class="px-4 text-caption font-weight-bold primaryGrey--text"
        v-if="chartData && updated_chart_data.length <= 1"
      >
        No data available
      </p>
      <GChart
        v-else
        type="PieChart"
        :data="updated_chart_data"
        :options="chartOptions"
        :events="chartEvents"
        @ready="onChartReady"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import TooltipVT from "../components/TooltipVT";

export default {
  name: "RadialChartVT",
  components: {
    TooltipVT,
  },
  props: {
    chartData: Array,
    title: String,
    subtitle: [String, Number],
    prefix: String,
    print: String,
    tooltip: String,
    customColors: Array,
    pieHole: Number,
    description: String,
  },
  data: function () {
    return {
      chart: null,
      chartEvents: {
        select: () => {
          let selection = this.chart.getSelection()[0];
          if (selection) {
            this.$emit("on-click", this.updated_chart_data[selection.row + 1][0]);
          } else {
            this.$emit("on-click", "");
          }
        },
        error: (errorObj) => {
          if (errorObj.message == "Data column(s) for axis #0 cannot be of type string")
            window.$(`#${errorObj.id} span`)[0].innerHTML =
              "Oops, there is no data available for the selected time period.";
        },
      },
    };
  },
  methods: {
    onChartReady(chart) {
      this.chart = chart;
    },
    createCustomHTMLContent(item) {
      return item
        ? `<div class='d-flex rounded custom-tooltip'>
      <div class='d-flex flex-column primaryDark--text px-2'>
        <div>
          ${item.title}
        </div>
        <div class='primaryGrey--text caption'>
          ${item.msg}
        </div>
        <div class='font-weight-bold py-1'>
          ${item.footer}
        </div>
      </div>
    </div> `
        : "";
    },
    get_style(color) {
      return {
        background: color,
      };
    },
  },
  created() {
    this.page_config = this.$config;
  },
  computed: {
    cardBackgroundColor() {
      return this.$vuetify.theme.dark && !this.print
        ? this.$vuetify.theme.themes.dark.backgroundWhite
        : this.$vuetify.theme.themes.light.backgroundWhite;
    },
    msg() {
      return this.$auth.error;
    },
    updated_chart_data() {
      let sum = 0;
      this.chartData &&
        this.chartData.map((x, index) => {
          if (index != 0) {
            sum = (typeof x[1] == "number" ? x[1] : 0) + sum;
          }
        });
      if (sum > 0) {
        var updated_chart_data = this.chartData.map((x, index) => {
          if (index == 0) return x;
          if (x[2]) {
            var tooltip_html = this.createCustomHTMLContent(x[2]);
            return [x[0], x[1], tooltip_html];
          } else {
            return [x[0], x[1]];
          }
        });
        return updated_chart_data;
      }
      return this.chartData ? [this.chartData[0]] : null;
    },
    colors() {
      let length = this.updated_chart_data.length;
      let slices = [{ color: "#0581c6" }, { color: "#e14615" }];
      if (length > 3) {
        slices.pop();
        for (var i = 1; i < length - 2; i++) {
          if (i == 1) slices[1] = { color: "#1a98ff" };
          if (i == 2) slices[2] = { color: "#52a0d1" };
          if (i == 3) slices[3] = { color: "#d9e6ff" };
        }
        slices.push({ color: "#e14615" });
      }
      return slices;
    },
    chartOptions() {
      let margin = 20;
      let size = "0.75em";
      if (this.print == "true") {
        margin = 50;
        size = 9;
      }
      return {
        backgroundColor: this.cardBackgroundColor,
        chartArea: {
          left: margin,
          top: 20,
          right: margin,
          bottom: 20,
          width: "94%",
        },
        slices: this.customColors || this.colors,
        pieHole: this.pieHole || 0.75,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "labeled",
          labeledValueText: "both",
          textStyle: {
            color: this.$vuetify.theme.dark && !this.print ? "#A9A9A9" : "#000",
            fontSize: size,
          },
        },
        tooltip: { isHtml: true },
        pieSliceText: "none",
        focusTarget: "category",
        sliceVisibilityThreshold: 0,
        width: "100%",
        animation: {
          duration: 1500,
          easing: "in",
          startup: true,
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.print-card .title-chart {
  font-size: 16px !important;
  font-weight: bold !important;

  .chart-subtitle {
    font-size: 14px !important;
    font-weight: bold !important;
  }
}

.fxd-height {
  min-height: 80px;
  align-items: flex-start;
}

::v-deep .custom-tooltip {
  width: 160px;
  min-height: 50px;
  max-height: 200px;
  border: none;
  box-shadow: -3px -1px 20px 0 rgba(0, 0, 0, 0.18), 0 6px 20px 0 rgba(153, 155, 168, 0.1);
}

::v-deep .google-visualization-tooltip {
  border: none !important;
  z-index: +1;
}

::v-deep svg > g > g:last-child {
  pointer-events: none;
}

::v-deep div.google-visualization-tooltip {
  pointer-events: none;
}

::v-deep svg text {
  font-size: 0.75rem;
}
</style>
